import { ImageSizesProps, ImageSourcesProps } from "../../../modernBlocks/modernBlocks.state";
import { ContentType, contentTypes } from "./searchPage.state";

export const searchFallBackImages = (id: number) => {
  return {
    image: {
      originalImageUrl: ``,
      altText: '',
      source: '',
      imageSizes: [
        // {
        //   style: '180x180',
        //   width: '180',
        //   height: '180',
        //   url: ``,
        // }
      ],
    } as ImageSizesProps['image'],
    imageSources: [
      {
        imageProportions: {
          width: '400',
          height: '225',
          sizes: 'auto',
          media: '(min-width: 768px)',
        },
        image: {
          originalImageUrl: ``,
          altText: '',
          source: '',
          imageSizes: [
            // {
            //   style: '400x225',
            //   width: '400',
            //   height: '225',
            //   url: ``,
            // },
            // {
            //   style: '800x450',
            //   width: '800',
            //   height: '450',
            //   url: ``,
            // },
          ]
        },
      }
    ] as ImageSourcesProps['sources']
  }
}

export const getContentTypeTitle = (type: ContentType) => {
  const typeTitle = contentTypes[type]

  if (!typeTitle) return "Pagina"
  return typeTitle
}